import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { IMPACT_OVERLAY_DATA } from '@libs/overlay';
import { SafePipe } from '@shared/safe/safe.pipe';
import { InterceptLinksDirective } from '../../../@shared/intercept-links/intercept-links.directive';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
    selector: 'app-dialog-rich-text',
    templateUrl: './dialog-rich-text.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DialogComponent, InterceptLinksDirective, SafePipe]
})
export class DialogRichTextComponent {
    constructor(@Inject(IMPACT_OVERLAY_DATA) public data: string) {}
}
